import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Container, AppBar, Toolbar, Typography, Button } from "@mui/material";
import Home from "./pages/Home";
import BusDetail from "./pages/BusDetail";
import Alerts from "./pages/Alerts";
import ReportIssue from "./pages/ReportIssue";
import LostFound from "./pages/LostFound";
import Admin from "./pages/Admin";

export default function App() {
  return (
    <Router>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Himachal Bus Tracker
          </Typography>
          <Button color="inherit" component={Link} to="/">Home</Button>
          <Button color="inherit" component={Link} to="/alerts">Alerts</Button>
          <Button color="inherit" component={Link} to="/report">Report</Button>
          <Button color="inherit" component={Link} to="/lostfound">Lost & Found</Button>
          {/* <Button color="inherit" component={Link} to="/admin">Admin</Button> */}
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bus/:busId" element={<BusDetail />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/report" element={<ReportIssue />} />
          <Route path="/lostfound" element={<LostFound />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Container>
    </Router>
  );
}
